import React from 'react';
import {
    getFeature,
    FEATURE__HIGHLIGHT_PREMIUM,
} from '../../utils/features';

import './BidNowButton.css';

var BidNowButton = function(props) {
    var title = props && props.title;
    var biddingUrl = props && props.biddingUrl;
    var premium = props && props.premium;

    if (!biddingUrl) {
        return null;
    }

    var showPremium = getFeature(FEATURE__HIGHLIGHT_PREMIUM) && premium;
    var className = 'al-bid-button' + (showPremium ? ' al-bid-button--premium' : '');

    return (
        <a
            href={biddingUrl}
            target="_blank"
            rel="noopener noreferrer"
            title={'Bid Now on ' + title + '. By clicking on any bidding or URL external link, you will leave this website and be directed to an external site.'}
            className={className}
        >
            Bid Now
        </a>
    );
};

export default BidNowButton;
